import { AccountResponse } from '../../models/account/AccountResponse';
import { IntercomUser } from '../../models/intercom/IntercomUser';
import { calculateTrialDaysRemaining, normalizeBillingCycle, toUnixSeconds } from './intercomDerivations';

export const transformToIntercomUser = (account: AccountResponse): IntercomUser => {
  const email = account.apiClientId && account.apiExternalAccountSettings?.originalEmail
    ? account.apiExternalAccountSettings.originalEmail
    : account.email;

  return {
    user_id: account.intercomUserId,
    user_hash: account.intercomUserHash,
    email,
    name: account.firstName || account.lastName
      ? `${account.firstName} ${account.lastName}`
      : account.email,
    created_at: toUnixSeconds(account.created) ?? Math.floor(Date.now() / 1000),
    external_user_id: account.userId,
    external_account_id: account.accountId,
    user_role: account.role,
    account_status: account.accountStatus,
    account_type: account.accountType,
    account_valid_to_at: toUnixSeconds(account.validToDate),
    account_is_cancelled: account.isCanceledAccount,
    account_trial_days_remaining: calculateTrialDaysRemaining(
      account.accountStatus,
      account.created,
      account.trialDays
    ),
    account_billing_cycle: normalizeBillingCycle(account.billingInterval),
    account_subscription_start_date: toUnixSeconds(account.startSubscription),
    account_max_monitors: account.maxMonitorCount,
    account_created_monitors: account.createdMonitorCount,
    account_users_on_account: account.usersOnAccount,
    account_max_users: account.maxUsers,
    api_client_id: account.apiClientId,
    api_client_name: account.apiClientName,
    is_guest: account.isGuest,
    is_password_set: account.isActive,
    account_registration_confirmed_at: toUnixSeconds(account.confirmedAt),
  };
};
